import {decorate, injectable} from '@yosmanyga/di'
import {SQLiteDatabase} from './ResolveSQLiteDb';

class MockSQLiteDbDatabase implements SQLiteDatabase {
    runAsync = jest.fn()
    execAsync = jest.fn()
    getFirstAsync = jest.fn()
    getAllAsync = jest.fn()
    closeSync = jest.fn()
}

class MockResolveSQLiteDb {
    resolve = jest.fn().mockReturnValue(new MockSQLiteDbDatabase())
    delete = jest.fn()
}

decorate(injectable(), MockResolveSQLiteDb)

export {
    MockResolveSQLiteDb
}
